const md = `# Workflows Library

## Browsing

The library is searchable and tag-filterable.  Tags include
*Procurement*, *Supplier Management*, *Onboarding* — click a tag to
filter.

## Immutable versions

Every workflow has a **current version** and a history of older
versions stored in \`workflow_versions\`.  When you run a workflow, the
runner snapshots the version it just ran against the run, so older
runs are reproducible even after the workflow has been re-edited.

## Editing

Builders and admins can click **Edit** on any workflow.  The editor
lets you reorder, add, delete, and tweak steps.  Each step is one of:

* **navigate** — go to a URL
* **fill** — type into an input/textarea
* **click** — click an element
* **pick_first** — open a combobox and pick its first option
* **settle_delay** — wait N ms for animation/network
* **screenshot** — save an explicit screenshot
* **evaluate_js** — run arbitrary JS in the page (returns JSON saved
  as a discovery artefact — see *Troubleshooting*)

When you save, you create a *new* version.  The library always points
at the latest active version; older versions remain bound to the runs
they produced.

## Custom workflows

Click **+ New workflow** to start from scratch.  You declare a name,
description, tags, variables, and a list of steps.  Variables can be
referenced from any step's \`value\` field as \`\${variable_name}\`.

## The auto-pipeline badge

Workflows with \`auto_pipeline=true\` show a small sparkles badge in
the library.  When you run them, narration + voice + MP4 are generated
automatically.  Toggle this on the workflow's edit page.
`;

export default md;
